import { AddressContext } from 'constants/contexts';
import useFetchedData from 'hooks/useFetchedData';
import {
  useContext,
  useMemo,
} from 'react';
import { useLocation } from 'react-router-dom';
import useMerchantIdOrSlug from './useMerchantIdOrSlug';

function useMerchant() {
  const idOrSlug = useMerchantIdOrSlug();
  const { state: { merchant: stateMerchant } = {} } = useLocation();
  const { currentAddress } = useContext(AddressContext);
  const { data: fetchedMerchant, error, loading } = useFetchedData(
    idOrSlug && {
      url: `v1/restaurants/${idOrSlug}/`,
      query: {
        lat: currentAddress?.lat,
        lng: currentAddress?.lng,
      },
    },
    ({ data } = {}) => data,
  );
  const merchant = useMemo(() => ({
    ...stateMerchant,
    ...fetchedMerchant,
  }), [stateMerchant, fetchedMerchant]);

  return { notFound: !idOrSlug || error, merchant, fetchedMerchant, loading };
}

export default useMerchant;
